import { createContext, useContext, useState, useEffect } from 'react'
import { login as apiLogin, logout as apiLogout, verifyToken } from '../api/auth'

const AuthContext = createContext(null)

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    // Check for existing token on mount
    const checkAuth = async () => {
      const token = localStorage.getItem('adminToken')
      if (token) {
        try {
          const userData = await verifyToken()
          setUser(userData)
        } catch {
          localStorage.removeItem('adminToken')
        }
      }
      setLoading(false)
    }
    checkAuth()
  }, [])

  const login = async (email, password) => {
    const response = await apiLogin(email, password)
    localStorage.setItem('adminToken', response.access_token)
    // Fetch user data after login
    const userData = await verifyToken()
    setUser(userData)
    return userData
  }

  const logout = () => {
    apiLogout()
    localStorage.removeItem('adminToken')
    setUser(null)
  }

  const value = {
    user,
    isAuthenticated: !!user,
    loading,
    login,
    logout,
  }

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>
}

export function useAuth() {
  const context = useContext(AuthContext)
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider')
  }
  return context
}
